import { useSelector } from 'react-redux';
import TableVertical, { TableVerticalInfoObject } from '../../misc/TableVertical';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';
import { CoreGoogleDevice } from '../../../models/CoreDeviceModels';
import StatusCode from '../../../util/StatusCode';
import { useTranslation } from "react-i18next";
import * as Helper from '../../../util/Helper';
import React, { useState } from "react";
import TableHorizontal from '../../misc/TableHorizontal';
import { InfoObject } from '../../misc/TableHorizontalPagedToggle';
import DeviceViewMap from './DeviceViewMap';


const DeviceViewInfo = () => {
    const { t } = useTranslation(['device', 'common']);

    const device = useSelector<RootState, RequestState<CoreGoogleDevice>>(state => state.device.googleDevice)
    const [show, setShow] = useState<boolean | undefined>(true)

    const getContent = () => {
        let deviceInfo: TableVerticalInfoObject[] = []
        let recentUsers: InfoObject[] = []

        if (device.code === StatusCode.COMPLETE) {
            const current = device.data;
            deviceInfo.push(
                { header: t('googleDeviceListing.tableHeaders.serialNumber', { ns: 'device' }), content: current.serialNumber },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(current.active) },
                { header: t('googleDeviceListing.tableHeaders.status', { ns: 'device' }), content: t(`googleDeviceListing.status.${current.status}`, { ns: 'device' }) },
                { header: t('googleDeviceListing.tableHeaders.lastSync', { ns: 'device' }), content: Helper.formatDateOnly(current.lastSync) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDateOnly(current.created) },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDateOnly(current.modified) },
                { header: t('genericTableHeaders.removed', { ns: 'common' }), content: Helper.formatDateOnly(current.removed) },
                { header: t('googleDeviceListing.tableHeaders.model', { ns: 'device' }), content: current.model },
                { header: t('googleDeviceListing.tableHeaders.osVersion', { ns: 'device' }), content: current.osVersion },
                { header: t('googleDeviceListing.tableHeaders.orgUnitPath', { ns: 'device' }), content: current.orgUnitPath },
                { header: t('googleDeviceListing.tableHeaders.lastEnrollmentTime', { ns: 'device' }), content: Helper.formatDateOnly(current.lastEnrollmentTime) },
                { header: t('googleDeviceListing.tableHeaders.autoUpdateExpiration', { ns: 'device' }), content: Helper.formatDateOnly(current.autoUpdateExpiration) },
                { header: t('googleDeviceListing.tableHeaders.annotatedAssetId', { ns: 'device' }), content: current.annotatedAssetId },
                { header: t('googleDeviceListing.tableHeaders.annotatedLocation', { ns: 'device' }), content: current.annotatedLocation },
                { header: t('googleDeviceListing.tableHeaders.annotatedUser', { ns: 'device' }), content: current.annotatedUser },
                { header: t('googleDeviceListing.tableHeaders.notes', { ns: 'device' }), content: current.notes },
                {
                    header: t('googleDeviceListing.tableHeaders.lastKnownNetwork', { ns: 'device' }), content: current.lastKnownNetwork
                        ? <DeviceViewMap lastKnownNetwork={current.lastKnownNetwork} deviceId={current.id} /> : '-'
                },
            )

            recentUsers = current.recentUsers?.map((u) => ({
                id: u.sortIndex.toString(),
                data: [
                    { value: u.emailAddress  },
                    { value: u.orgUnitPath },
                    { value: u.googleId },
                    { value: t(`device.deviceInfo.recentUserType.${u?.type}`, { ns: 'device' }) },
                ]
            })) ?? [];

        }
        return (
            <div>
                <TableVertical
                    header={t('device.deviceInfo.information', { ns: 'device' })}
                    info={deviceInfo}
                    error={device.code === StatusCode.ERROR}
                    searching={device.code === StatusCode.PENDING}
                />

                <TableHorizontal
                    header={[
                        { value: t('googleDeviceListing.tableHeaders.recentUserEmail', { ns: 'device' }) },
                        { value: t('googleDeviceListing.tableHeaders.orgUnitPath', { ns: 'device' }) },
                        { value: t('googleDeviceListing.tableHeaders.recentUserGoogleId', { ns: 'device' }) },
                        { value: t('googleDeviceListing.tableHeaders.recentUserType', { ns: 'device' }) }
                    ]}
                    info={recentUsers}
                    error={device.code === StatusCode.ERROR}
                    searching={device.code === StatusCode.PENDING}
                    displayName={t('googleDeviceListing.tableHeaders.recentUsers', { ns: 'device' })}
                    showHeader={true}
                    noResMsg={t('device.notFoundUsers', { ns: 'device'})}
                    displayToggle={true}
                    show={show}
                    toggle={() => setShow(!show)}
                />
            </div>
        )
    }

    return (<>
        {getContent()}
    </>);
}

export default DeviceViewInfo;
